// extracted by mini-css-extract-plugin
export default {"recipe":"RecipeDetails_recipe__ZaGa2"};